import React from "react";
import "./UserDetail.scss";
import UserDetail from "components/userManagement/userDetail/UserDetail";

const UserDetail1 = () => {
  return (
    <>
      <UserDetail />
     
    </>
  );
};

export default UserDetail1;
